import { oz } from '@weft/utils';

export const RevenuePerMonthBreakdownSchema = oz.object({
  scheduledCharge: oz.number(),
  revenue: oz.number(),
  deferredRevenue: oz.number(),
  unbilledRevenue: oz.number(),
});

export type RevenuePerMonthBreakdown = oz.infer<typeof RevenuePerMonthBreakdownSchema>;
